module.exports = __webpack_public_path__ + "static/media/tiempo_mobile.47effc2f.svg";